// components/Loader.js
import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Take up the full viewport height
        width: '100%', // Take up the full viewport width
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent overlay
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
